<template>
  <b-container>
    <!-- {{moduleId}} -->
    <pendencies-details :moduleId="moduleId" :id="id"></pendencies-details>
  </b-container>
</template>
<script>
export default {
  name: "ModulePendenciesDetails",
  props:{
    moduleId: String,
    id: String, 
  },
  components: {
    PendenciesDetails: () => import("src/pagesRms/checklist/pendency/PendenciesDetails.vue")
  },
};
</script>

